import { css } from 'styled-components';
import { colors } from '../../../../common/components/styles/colors';

export const boxShadow = (color = colors.black) => css`
  box-shadow: 0 10px 15px 0 ${color};
`;
